/**
 * Laster pdf-viewer-komponentene (og dermed pdfjs-dist) ved første bruk (#13442).
 *
 * En statisk import av ./index.js ville dratt hele pdfjs inn i entry-bundelen.
 * Alle som bruker <pdf-viewer>-taggen kaller denne fra connectedCallback i
 * stedet — Lit oppgraderer elementene i templaten når modulen er lastet og
 * custom element-ene registreres.
 */
export function loadPdfViewer(): Promise<unknown> {
  return import('./index.js');
}
